import MarkdownContainer from "~/components/markdown-container/markdown-container";
import { GamgeeChatMessageRead } from "~/types/message";
import styles from "./update-window.module.css";

interface UpdateWindowProps {
  title: string;
  content: string;
  isStreaming: boolean;
  message: GamgeeChatMessageRead;
}

const UpdateWindow = ({title, content, isStreaming, message}: UpdateWindowProps) => {
  return (
    <div className="collapse collapse-arrow bg-base-100 border-base-300 border w-full">
      <input type="checkbox" />
      <div className="collapse-title font-semibold">
        <div className={`${styles.updateTitle} ${isStreaming ? styles.shimmer : ''}`}>
          <span>{title}</span>
        </div>
      </div>
      <div className="collapse-content text-sm w-full overflow-auto">
        <div className="w-full max-h-96 overflow-x-auto overflow-y-auto">
          <MarkdownContainer message={message}>
            {content}
          </MarkdownContainer>
        </div>
      </div>
    </div>
  )
}

export default UpdateWindow;
